import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { ic_close_small as NormalCloseIcon } from 'app/widgets/SVGs';

interface Props {
  label: string;
  onClick: () => void;
}

export default function Chip({ label, onClick }: Props) {
  return (
    <span>
      <Button className="button-tag-close" onClick={onClick}>
        {label}
        <NormalCloseIcon />
      </Button>
    </span>
  );
}
